import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import SecureModuleIndex from "../secure/SecureModuleIndex";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_INSTITUTIONS, GET_ALL_LHD } from "../../queries/publicQrys/UserAccessQrys";
import { Button, MultiSelect, MultiSelectOption, Modal, ModalTitle, ModalContent, ModalFooter } from "@utahdts/utah-design-system";
import "./PortalAccessForm.css";
import "./public.css";
import { useMutation } from "@apollo/client";
import { REQUEST_ACCESS } from "../../queries/publicQrys/UserAccessQrys";
import RequestAccessSuccess from "./RequestAccessSuccess";
import MultiSelectWaterSystems from "../reuseableComponents/waterSystems/MultiSelectWaterSystems";

const PortalAccessForm = (props) => {
    const [accountName, setAccountName] = useState("");
    const [accountNameError, setAccountNameError] = useState(false);
    const [accountDescription, setAccountDescription] = useState("");
    const [accountDescriptionError, setAccountDescriptionError] = useState(false);

    const [institutionTypes, setInstitutionTypes] = useState([]);
    const [getInstitutionTypes, InstitutionTypesResult] = useLazyQuery(GET_ALL_INSTITUTIONS);

    const [lhdTypes, setLHDTypes] = useState([]);
    const [getLHDTypes, lhdTypeResult] = useLazyQuery(GET_ALL_LHD);

    // State to store selected values
    const [selectedWaterSystems, setSelectedWaterSystems] = useState([]);
    const [assignedWaterSystems, setAssignedWaterSystems] = useState([]);
    const [selectedInstitutions, setSelectedInstitutions] = useState([]);
    const [selectedLhds, setSelectedLhds] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);
    const [requestAccess, { data, reset }] = useMutation(REQUEST_ACCESS, {
        onError: (error) => {
            setErrorMessage(`${error.name}: ${error.message}`);
          },
        onCompleted: (result) => {
            if (result?.requestAccess === false) {
                setErrorMessage("An unknown error occurred. Please try again.");
            } 
          }
    });

    useEffect(() => {
        Promise.all([getInstitutionTypes(), getLHDTypes()])
            .then(([InstitutionTypesResult, lhdTypeResult]) => {
                if (InstitutionTypesResult.data && InstitutionTypesResult.data.getAllInstitutions) {
                    setInstitutionTypes(InstitutionTypesResult.data.getAllInstitutions);
                }
                if (lhdTypeResult.data && lhdTypeResult.data.getAllLHD) {
                    setLHDTypes(lhdTypeResult.data.getAllLHD);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [getInstitutionTypes, getLHDTypes]);

    const { user } = useContext(UserContext);

    const handleWaterSystemChange = (selectedValues) => {
        setSelectedWaterSystems(selectedValues);
    };

    const handleAssignedWaterSystemsChange = (selectedSystems) => {
        setAssignedWaterSystems(selectedSystems);
    };

    const handleLHDChange = (selectedValues) => {
        setSelectedLhds(selectedValues);
    };

    const handleInstChange = (selectedValues) => {
        setSelectedInstitutions(selectedValues);
    };

    const handleCancelClick = (event) => {
        window.location.href = '/public/request-access'
    }

    const handleCloseErrorModal = () => {
        setErrorMessage(null);
        reset();
    }

    const handleAccountNameChange = (e) => {
        const value = e.target.value;
        setAccountName(value);
      
        // Check if the input is valid
        if (value.trim() === "") {
          setAccountNameError(true); // Set error if the field is empty
        } else {
          setAccountNameError(false); // Clear error if the field is valid
        }
    };

    const handleAccountDescriptionChange = (e) => {
        const value = e.target.value;
        setAccountDescription(value);
      
        // Check if the input is valid
        if (value.trim() === "") {
          setAccountDescriptionError(true); // Set error if the field is empty
        } else {
          setAccountDescriptionError(false);// Clear error if the field is valid
        }
    };

    const onSubmit = (event) => {
        if(accountName === "") {
            setAccountNameError(true);
            return;
        }
        if(accountDescription === "") {
            setAccountDescriptionError(true);
            return;
        }
        const userRequest = {
          umd_id: user.umdId,
          requestAccessType: "portal",
          accountName: accountName,
          accountDescription: accountDescription,
                    assignedSystems: assignedWaterSystems,
          assignedLhds: selectedLhds.map(lhdName => {
            const lhd = lhdTypes.find(lt => lt.lhd_name === lhdName);
            return { lhd_id: lhd.lhd_id, lhd_name: lhd.lhd_name }
          }),
          assignedInstitutions: selectedInstitutions.map(instName => {
            const inst = institutionTypes.find(it => it.institutionName === instName);
            return { institutionId: inst.institutionId, institutionName: inst.institutionName }
          })
        }
    
        requestAccess({
          variables: {
            input: userRequest,
          },});
      }

    if (InstitutionTypesResult.loading || lhdTypeResult.loading) {
        return <div>loading..</div>
    }

    return (
        <>
            {user.isPublic ? (
                <div className="utah-design-system" >
                    <Row>
                        <Col>
                            <div id="landingPageContainer">
                                <div className="portal-access-hero" style={{ backgroundImage: `url(${bgImage})` }}>
                                    <div className="portal-access-hero-logo-wrapper">
                                        <div className="portal-access-logo-container">
                                            <img src={mtnLogo} alt='Mountain Logo' className="portal-access-logo-img" />
                                        </div>
                                        <br />
                                        <h1 className="portal-access-title">
                                            Request Access Portal
                                        </h1>
                                        <br />
                                    </div>
                                    <div className="portal-access-bottom-section" style={{ backgroundImage: `url(${bgBottom})` }}>
                                    {errorMessage && (
                                        <div className="utah-design-system">
                                            <Modal
                                            aria-labelledby="access-request-failure"
                                            className="modal--medium center"
                                            id="modal-example"
                                            >
                                            <ModalTitle id="access-request-failure">
                                                Something went wrong
                                            </ModalTitle>
                                            <ModalContent>
                                                {errorMessage}
                                            </ModalContent>
                                            <ModalFooter className="flex float-right flex-wrap">
                                                <Button onClick={handleCloseErrorModal}>Close</Button>
                                            </ModalFooter>
                                            </Modal>
                                        </div>
                                    )}
                                    {data?.requestAccess === true ? (<RequestAccessSuccess/>) : (
                                        <div className="portal-access-bottom-content">
                                            <div className="portal-access-button-container">
                                                <Form className="portal-access-form">
                                                    <Row className="justify-content-center"> {/* Wrap the fields in a Row */}
                                                        <Col xs={6}> {/* Account Name column */}
                                                            <Form.Group controlId="accountName" className="portal-access-form-group">
                                                                <Form.Label className="portal-access-form-label"> Account Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    className="portal-access-text-input-full"
                                                                    value={accountName}
                                                                    onChange={handleAccountNameChange}
                                                                    isInvalid={accountNameError}
                                                                    required
                                                                    aria-required="true"
                                                                    aria-invalid={accountNameError}
                                                                    aria-describedby={accountNameError ? "accountNameError" : undefined}
                                                                />
                                                                <Form.Control.Feedback id="accountNameError" type="invalid">
                                                                    Account Name is required.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>

                                                            <Form.Group controlId="waterSystems" className="portal-access-form-group">
                                                                <MultiSelectWaterSystems
                                                                    selectedWaterSystems={selectedWaterSystems}
                                                                    onChange={handleWaterSystemChange}
                                                                    onAssignedSystemsChange={handleAssignedWaterSystemsChange}
                                                                    className="access-form-multiselect"
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={6}> {/* Account Description column */}
                                                            <Form.Group controlId="accountDescription" className="portal-access-form-group">
                                                                <Form.Label className="portal-access-form-label">
                                                                    Account Description/Justification
                                                                </Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={3}
                                                                    className="portal-access-text-input-full"
                                                                    value={accountDescription}
                                                                    onChange={handleAccountDescriptionChange}
                                                                    isInvalid={accountDescriptionError}
                                                                    required
                                                                    aria-required="true"
                                                                    aria-invalid={accountDescriptionError}
                                                                    aria-describedby={accountDescriptionError ? "accountDescriptionError" : undefined}
                                                                />
                                                                <Form.Text className="text-muted portal-access-char-count">
                                                                    {accountDescription.length}/255
                                                                </Form.Text>
                                                                <Form.Control.Feedback id="accountDescriptionError" type="invalid">
                                                                    Account Description is required.
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col xs={6}>
                                                            <Form.Group controlId="localHealthDepartments" className="portal-access-form-group">
                                                                <MultiSelect
                                                                    id="lhd"
                                                                    label="Local Health Departments"
                                                                    onChange={handleLHDChange}
                                                                    values={selectedLhds}
                                                                    className="access-form-multiselect"
                                                                    placeholder="Select Health Departments"
                                                                    autoComplete="off"
                                                                >{lhdTypes.map((lhd) => (
                                                                    <MultiSelectOption key={lhd.lhd_id} label={lhd.lhd_name} value={lhd.lhd_name} />
                                                                ))}
                                                                </MultiSelect>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={6}>
                                                            <div className="portal-access-institutions-wrapper">
                                                                <Form.Group controlId="institutionsEntities" className="portal-access-form-group">
                                                                    <MultiSelect
                                                                        id="institutions"
                                                                        label="Institutions/Entities"
                                                                        onChange={handleInstChange}
                                                                        values={selectedInstitutions}
                                                                        className="access-form-multiselect"
                                                                        placeholder="Select Institutions"
                                                                        autoComplete="off"
                                                                    >
                                                                        {institutionTypes.map((gt) => (
                                                                            <MultiSelectOption key={gt.institutionId} label={gt.institutionName} value={gt.institutionName} />
                                                                        ))}
                                                                    </MultiSelect>
                                                                </Form.Group>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                    <div className="utah-design-system portal-access-button-container portal-access-action-buttons">
                                                        <Button appearance="outlined" color="primary" onClick={() => { handleCancelClick() }}>
                                                            Cancel
                                                        </Button>
                                                        <Button appearance="solid" color="primary" onClick={() => { onSubmit() }} >
                                                            Submit
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            ) : (
                <SecureModuleIndex />
            )}
        </>
    );
};
export default PortalAccessForm;